import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuIcon from '@mui/icons-material/Menu';
// import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
// import {Badge} from "@mui/material";
import {LeftMenuSection} from "./leftMenuSection";
import {RightMenuSection} from "./rightMenuSection";

// const stringAvatar = (name) => {
//     const match = name.match(/\s(.)/);
//     const secondChar = match ? match[1].toUpperCase() : name.charAt(1).toUpperCase();
//     return {
//         children: name.charAt(0).toUpperCase() + secondChar
//     };
// }

export const TopHeaderSection = () => {

    const [openLeftMenu, setOpenLeftMenu] = React.useState(false);

    const toggleDrawerLeftMenu = (newOpen) => () => {
        setOpenLeftMenu(newOpen);
    };
    const [openRightMenu, setOpenRightMenu] = React.useState(false);

    const toggleDrawerRightMenu = (newOpen) => () => {
        setOpenRightMenu(newOpen);
    };
    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar sx={{background: 'rgb(43, 48, 51)',py:1}} position="static">
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{ mr: 2,borderRadius:'8px',py:0.5,px:1.5}}
                        onClick={toggleDrawerLeftMenu(true)}
                    >
                        <MenuIcon sx={{ fontSize: 30, color:'rgba(255,255,255,0.7)'}} />
                    </IconButton>
                    <Typography
                        color='#fff'
                        variant="div"
                        noWrap
                        component="div"
                        fontSize={'25px'}
                        fontWeight="700"
                        sx={{ display: { xs: 'none', sm: 'block' } }}
                    >
                        Roadway Moving
                    </Typography>

                    <Box sx={{ flexGrow: 1,px:8}} align="right">
                        {/*<Typography variant="h2" color="inherit" component="div" align="center" fontWeight="400">*/}
                        {/*    Claims*/}
                        {/*</Typography>*/}
                        {/*<Badge badgeContent={12567} color="error" align="center" max={99999}>*/}
                        {/*    <EmailOutlinedIcon color="#fff" sx={{ fontSize: 35 }}/>*/}
                        {/*</Badge>*/}
                    </Box>
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <IconButton
                            size="large"
                            aria-label="show 17 new notifications"
                            color="inherit"
                            onClick={toggleDrawerRightMenu(true)}
                        >
                            <Typography variant="div" color="inherit" component="div" align="center" fontWeight="400" fontSize={'14px'}>
                                Arman Shavelyan
                            </Typography>
                            <KeyboardArrowDownIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            <LeftMenuSection toggleDrawerLeftMenu={toggleDrawerLeftMenu} open={openLeftMenu}/>
            <RightMenuSection toggleDrawerRightMenu={toggleDrawerRightMenu} open={openRightMenu}/>
        </Box>
    );
}
